export default "__VITE_ASSET__CqFTcmp1__"